export default __webpack_public_path__ + "static/media/c.636484d7.jpg";